<template>
  <div class="SectionOpen">
    <div
      class="title"
      :class="{ active: isOpen }"
      @click="isOpen = !isOpen"
      @keydown.enter="isOpen = !isOpen">
      <div v-html="title" />
      <div class="icon">
        <Btn class="arrow no-text" :class="{ up: isOpen, down: !isOpen }" />
      </div>
    </div>
    <transition name="slide-fade">
      <div v-show="isOpen" class="answer">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    answer: Array,
    title: String,
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>

<style lang="scss">
.SectionOpen {
  background: $white-ter;
  border-bottom: 1px solid $border-color;
  border-radius: $radius 0;
  box-shadow: $shadow-sm;
  margin-bottom: 1rem;
  padding: 2rem;

  > .title {
    cursor: pointer;
    display: flex;
    font-size: $h4;
    font-weight: $bold;
    justify-content: space-between;
    padding: 1rem 0;
    position: relative;
    @include lg {
      font-size: $h25;
      line-height: 2.5rem;
    }

    > .icon {
      align-items: center;
      color: $yellow;
      display: flex;
      float: right;
      // font-size: $h3;
      padding: 0 0.5rem;
      @include lg {
        font-size: $h2;
      }

      > .Btn {
        border: 1px solid $black;
        width: unset;

        .circle {
          margin-left: -1rem;
        }
      }
    }

    // &.active {
    //   border-bottom: 2px solid $text-color;
    // }
  }

  > .answer {
    padding-top: 1rem;

    p {
      font-size: $h5;
      margin-bottom: 1rem;
      @include lg {
        font-size: $h4;
        line-height: 2rem;
      }
    }
  }
}
</style>
